<template lang="pug">
#people-container.grid-scroll-more(v-scrolled-to-end='fetchMore')
  PageHeader(headerText='People', :sortOptions='sortOptions', @sortBy='setSortOrder')
  GridDisplay(:entities='users')
</template>

<script>
import { mapGetters } from 'vuex'
import fetchAndSort from '@/mixins/fetchAndSort'

export default {
  mixins: [fetchAndSort],
  props: {},

  data() {
    return {
      fetchType: 'users/fetch',
      sortOrder: 'recent',
      sortOptions: ['recent', 'most likes'],
    }
  },
  channels: {
    PeopleChannel: {
      connected() {},
      rejected() {},
      received(data) {
        if (this.sortOrder == 'recent') {
          this.$store.commit('users/ADD_OR_UPDATE', data)
        } else {
          this.$store.commit('users/UPDATE', data)
        }
      },
      disconnected() {},
    },
  },

  computed: {
    ...mapGetters({
      sortBy: 'users/sortBy',
    }),
    users,
  },

  watch: {},

  async created() {
    await this.fetchRecords()
  },

  mounted() {
    this.$cable.subscribe({ channel: 'PeopleChannel' })
  },

  methods: {},

  components: {
    GridDisplay: require('@/components/GridDisplay').default,
    PageHeader: require('@/components/PageHeader').default,
  },
}

/* Computed ---------------------------------------------------- */
function users() {
  return this.sortBy(this.sortOrder)
}
/* Watch ------------------------------------------------------- */
/* Methods ----------------------------------------------------- */
</script>
